import * as React from "react"
import * as styles from '../styles/hero_image_section.module.css'


export function HeroImageSection() {
    return (
        <section className={styles.hero_image}>
          <div className={styles.hero_image_box}>
            <picture>
              <source media="(max-width: 1023px)" srcSet="sp/hero.webp" />
              <source media="(min-width: 1024px)" srcSet="pc/hero.webp" />
              <img className={styles.hero_image_body} 
                src="sp/hero.jpg"
                alt="アイリスオデッセイ アイリス オデッセイ タイトル画像"/>
            </picture>
            <img className={styles.logo} src="sp/title.png" alt="title"/>
            <img className={styles.small_steam_logo} src="icon/steam_black.png" alt="small_steam_logo"/>
          </div>
        </section>
    )
}